import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  UserRegistrationData,
  UserSignInData,
} from '../constants/user-registration.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserRegistrationService {
  constructor(private http: HttpClient) {}

  registerUser(data: UserRegistrationData): Observable<any> {
    return this.http.post('/api/userSignUp/registration', data);
  }
  verifyUser(token: string): Observable<any> {
    return this.http.post('/api/userSignUp/verifyemail', token);
  }

  signin(data: UserSignInData): Observable<any> {
    return this.http.post('/api/userSignUp/signin', data);
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post(
      `/api/userSignUp/forgotPassoword?email=${email}`,
      null
    );
  }

  resetPassword(data: { token: string; password: string }): Observable<any> {
    return this.http.post('/api/userSignUp/resetPassword', data);
  }
}
